import { useQuery, useMutation, useQueryClient, UseQueryResult, UseMutationResult } from 'react-query';
import { IAddCardResponse, INewCard, IPaymentCard } from 'src/interfaces/IMedspaAdminList';
import { PAYMENT_METHODS } from 'src/constants/reactQuery.keys';
import PaymentMethods from 'src/services/medspaAdmins/PaymentMethods';

interface IUseAddCardError {
  response: { data: IAddCardResponse };
}

const useGetCards = (userGroupId: number, enabled: boolean = true): UseQueryResult<IPaymentCard[]> =>
  useQuery<IPaymentCard[]>({
    queryKey: [PAYMENT_METHODS],
    queryFn: (): Promise<IPaymentCard[]> => PaymentMethods.getCards(userGroupId),
    refetchOnWindowFocus: false,
    enabled,
  });

type useAddCardType = UseMutationResult<IAddCardResponse, IUseAddCardError, INewCard, unknown>;
const useAddCard = (userGroupId: number): useAddCardType => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: INewCard): Promise<IAddCardResponse> => PaymentMethods.addCard(userGroupId, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PAYMENT_METHODS] });
    },
  });
};

export { useAddCard, useGetCards, useGetCards as default };
